<template>
  <div class="view pa24">
    <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
      :close-on-click-modal="false">
      <el-form :model="ruleForm" ref="dealerRuleForm" label-width="140px" class="ruleForm">
        <el-form-item label="所属父级" prop="parentName">
          <el-input v-model="ruleForm.parentName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="ruleForm.unit" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="规格" prop="specName">
          <el-input v-model="ruleForm.specName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="件号" prop="partNumber">
          <el-input v-model="ruleForm.partNumber" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="型号" prop="modelNo">
          <el-input v-model="ruleForm.modelNo" :readonly="isShow"></el-input>
        </el-form-item>  
        <el-form-item label="缩略规格" prop="specCode"  v-if="companyName.includes('利佳')">
          <el-input v-model="ruleForm.specCode" :readonly="isShow"></el-input>
        </el-form-item>  
        <el-form-item label="材料牌号" prop="goodsCode"  v-if="companyName.includes('利佳')">
          <el-input v-model="ruleForm.goodsCode" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="存货编码" prop="inventCode">
          <el-input v-model="ruleForm.inventCode" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="库存预警数" prop="stockWarningNum"  v-if="companyName.includes('利佳')">
          <el-input-number v-model="ruleForm.stockWarningNum" :disabled="isShow"></el-input-number>
        </el-form-item>
        <el-form-item label="是否需要备件" prop="needSpare">
          <el-radio-group v-model="ruleForm.needSpare" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒SCM系统" prop="isRemindScm" v-if="ruleForm.needSpare">
          <el-radio-group v-model="ruleForm.isRemindScm" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否提醒APS系统" prop="isRemindAps" v-if="ruleForm.needSpare && companyName.includes('利佳')">
          <el-radio-group v-model="ruleForm.isRemindAps" size="small" :disabled="isShow">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="客户名称" prop="inventCode" v-if="companyName.includes('五洲')"> 
          <el-input v-model="ruleForm.customerName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="公差" prop="gongcha" v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.gongcha" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="铜粉" prop="tongfen"  v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.tongfen" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="铜粉厚度" prop="tongfenHd"  v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.tongfenHd" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="外观" prop="appearance" v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.appearance" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="油穴" prop="youxue" v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.youxue" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="送货备注" prop="deliverRemarks" v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.deliverRemarks" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="面积/重量" prop="areaWeight" v-if="companyName.includes('五洲')">
          <el-input v-model="ruleForm.areaWeight" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" v-model="ruleForm.sort" :readonly="isShow"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isShow">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button class="btncss">确 定</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isShow">
        <el-button @click="closeDialog">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchClassDetail } from '@/api/customPageClass.js'

  export default {
    name: "addPageClass",
    components: {
      // BaiduMap,

    },
    props: [],

    data() {
      let token = localStorage.getItem("token")
      return {
        dialogVisible: false,
        userInfo: '',
        companyName: '',
        title: '查看产品类别',
        parentId: '',
        parentName: '顶级',
        treeProps: {
          children: 'children',
          label: 'name',
          isLeaf: 'isLeaf'
        },
        expandOnClickNode: false,
        unitList: [],
        ruleForm: {
          id: '',
          name: '',
          sort: 999,
          parentId: null,
          busName: '',
          goodsCode: '',
          specCode: '',
          specName: '',
          classType: 0,
          stockWarningNum: '',
          partNumber: '',
          isRemindScm: false,
          isRemindAps: false,
          productQualification: '',
          isNeedOutsourcing: false,
          detectionBatchNo: '',
          certQuality: '',
          certValidity: '',
          productQualificationList: [],
          certQualityList: [],
          needSpare: false,
          inventCode: '',
          modelNo: '',
          unit: ''
        },
        isShow: false
      };
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }

    },
    onShow() {

    },
    mounted() {

    },
    methods: {
      openDialog(id) {
        this.title = '查看产品类别'
        this.isShow = true
        fetchClassDetail({ id: id }).then(res => {
          if (res.code == 200) {
            this.ruleForm = res.data
            if (!this.ruleForm.parentId) {
              this.ruleForm.parentName = '顶级'
            }
            this.dialogVisible = true
          }
        })
      },
      closeDialog() {
        this.$emit('closeDialog')
        this.dialogVisible = false
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10rpx;
  }
</style>